import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-409a21d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"line-height":"34px","vertical-align":"middle","font-weight":"bold"} }, "Sort:", -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "card-catelog" }
const _hoisted_5 = { class: "card-price" }

import { ShoppingCartPlus, ArrowUp, ArrowDown } from "@vicons/tabler";
import { NGrid, NGridItem, NSelect, NSpace, NIcon, NButton, NCard, SelectOption } from 'naive-ui'
import { ref, onMounted, h } from 'vue'

import { useProductStore } from '@/stores/ProductStore';
import { iViewProduct } from "@/types/ViewProduct";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const store = useProductStore();
const sortValue = ref('PriceASC');


onMounted(() => {
  store.sortProductsPriceAsc();
})


const renderLabel = function (option: SelectOption) {
  const optionVal = option.value?.toString().toLowerCase();

  if (!["asc", "desc"].some(el => optionVal?.includes(el))) {
    return option.label as string;
  }
  else {
    return [
      option.label as string,
      h(
        NIcon,
        {
          style: {
            verticalAlign: '-0.15em',
            marginRight: '4px'
          }
        },
        {
          default: () => h(
            optionVal?.includes("asc") ? ArrowUp : ArrowDown
          )
        }
      )
    ]
  }
}

const handleSortValue = function (value: string) {
  if (value == 'Default') {
    store.sortProductsDefault();
  }
  else if (value == 'NameASC') {
    store.sortProductsNameAsc();
  }
  else if (value == 'NameDESC') {
    store.sortProductsNameDesc();
  }
  else if (value == 'PriceASC') {
    store.sortProductsPriceAsc();
  }
  else if (value == 'PriceDESC') {
    store.sortProductsPriceDesc();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(NSpace), { vertical: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(NSelect), {
            value: sortValue.value,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => ((sortValue).value = $event)),
              handleSortValue
            ],
            placeholder: "Sort",
            style: {"width":"100px"},
            color: "#71c8cb",
            "render-label": renderLabel,
            options: [{
          label: 'Catalog',
          value: 'Default'
        }, {
          label: 'Name',
          value: 'NameASC'
        },
        {
          label: 'Name',
          value: 'NameDESC'
        },
        {
          label: 'Price',
          value: 'PriceASC'
        },
        {
          label: 'Price',
          value: 'PriceDESC'
        }]
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_unref(NGrid), {
        "x-gap": 12,
        "y-gap": 8,
        cols: "2 550:3 750:4",
        class: "product-grid"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).filteredProducts, (product, index) => {
            return (_openBlock(), _createBlock(_unref(NGridItem), {
              key: product.name + '-' + index
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NCard), null, {
                  cover: _withCtx(() => [
                    _createElementVNode("img", {
                      style: {"box-sizing":"border-box"},
                      src: require(`@/assets/img/products/${product.image}`)
                    }, null, 8, _hoisted_2)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: '/product/' + index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(product.name + ((product.details === '') ? '' : ' - ' + product.details)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(product.catelogId), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString((typeof (product.price) === 'number') ?
                '$ ' + (product.price / 100 * 75).toFixed(2).toString() + ',-' :
                product.price), 1),
                    _createVNode(_unref(NButton), {
                      bordered: "",
                      type: "info",
                      color: "#71c8cb",
                      onClick: ($event: any) => (_unref(store).addToCart(product)),
                      ghost: !(product as iViewProduct).hovered,
                      onMouseover: ($event: any) => ((product as iViewProduct).hovered = true),
                      onMouseleave: ($event: any) => ((product as iViewProduct).hovered = false)
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(NIcon), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ShoppingCartPlus))
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Add to cart ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "ghost", "onMouseover", "onMouseleave"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})